export default {"src":"/_next/static/media/data-encryption-and-secure-communication.3ec2241d.svg","height":590,"width":590,"blurWidth":0,"blurHeight":0};